import * as go from 'gojs';
import theme from 'theme/theme';
import { SMART_SELECT_PLACEMENT_PREVIEW_IMAGE_NAME } from './smartSelectConstants';
import {
  getPlacementArrowPoints,
  getPlacementPreviewBounds,
} from './smartSelectGeometry';

const $ = go.GraphObject.make;

type FreePortArrowPoints = {
  start: go.Point;
  end: go.Point;
};

type FreePortArrowOptions = {
  mouseEnter?: (event: go.InputEvent, obj: go.GraphObject) => void;
  mouseLeave?: (event: go.InputEvent, obj: go.GraphObject) => void;
  dotted?: boolean;
};

export const createSmartSelectPlacementPreview = (
  node: go.Node,
  port: go.GraphObject,
) => {
  const previewBounds = getPlacementPreviewBounds(node, port);

  return $(
    go.Part,
    'Auto',
    {
      layerName: 'Tool',
      zOrder: 2,
      selectable: false,
      pickable: false,
      position: new go.Point(previewBounds.x, previewBounds.y),
      isInDocumentBounds: false,
    },
    $(go.Shape, 'RoundedRectangle', {
      width: previewBounds.width,
      height: previewBounds.height,
      parameter1: 8,
      fill: 'transparent',
      stroke: theme.palette.info.main,
      strokeWidth: 1,
      strokeDashArray: [1, 4],
      strokeCap: 'round',
    }),
    $(go.Picture, {
      name: SMART_SELECT_PLACEMENT_PREVIEW_IMAGE_NAME,
      source: '',
      visible: false,
      desiredSize: new go.Size(
        previewBounds.width - 16,
        previewBounds.height - 16,
      ),
      imageStretch: go.GraphObject.Uniform,
      alignment: go.Spot.Center,
    }),
  );
};

export const createFreePortArrowLink = (
  arrowPoints: FreePortArrowPoints,
  options: FreePortArrowOptions = {},
) => {
  const { dotted = false, ...linkOptions } = options;

  return $(
    go.Link,
    {
      layerName: 'Tool',
      zOrder: 1,
      selectable: false,
      pickable: true,
      opacity: 0.5,
      isInDocumentBounds: false,
      routing: go.Link.Normal,
      curve: go.Link.None,
      points: new go.List<go.Point>().addAll([
        arrowPoints.start,
        arrowPoints.end,
      ]),
      ...linkOptions,
    },
    $(go.Shape, {
      isPanelMain: true,
      stroke: 'transparent',
      strokeWidth: 24,
    }),
    $(go.Shape, {
      isPanelMain: true,
      stroke: theme.palette.info.main,
      strokeWidth: 2,
      strokeDashArray: dotted ? [1, 4] : [4, 3],
      strokeCap: dotted ? 'round' : 'butt',
    }),
    $(go.Shape, {
      toArrow: 'Triangle',
      fill: theme.palette.info.main,
      stroke: theme.palette.info.main,
      strokeWidth: 0,
    }),
  );
};

export const createSmartSelectPlacementArrow = (
  node: go.Node,
  port: go.GraphObject,
) => {
  const arrowPoints = getPlacementArrowPoints(node, port);

  if (!arrowPoints) {
    return null;
  }

  return createFreePortArrowLink(arrowPoints, { dotted: true });
};
